import { createContext, useContext, useEffect, useState } from "react";

// Infraestructura de datos
import { pagarFacturaUseCase } from "../../../core/facturacion/application/pagarFactura.usecase.js";
import { cancelarFacturaUseCase } from "../../../core/facturacion/application/cancelarFactura.usecase.js";

// Contexto
const FacturasContext = createContext();

export function FacturasProvider({ children }) {
  const [facturas, setFacturas] = useState(() => {
    const guardadas = localStorage.getItem("facturasPendientes");
    return guardadas ? JSON.parse(guardadas) : [];
  });

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  // Persistir cambios en localStorage
  useEffect(() => {
    localStorage.setItem("facturasPendientes", JSON.stringify(facturas));
  }, [facturas]);

  // Agregar facturas pendientes
  const agregarFacturas = (nuevas = []) => {
    console.log("[FacturasContext] Agregando facturas:", nuevas);
    setFacturas((prev) => [...prev, ...nuevas]);
  };

  // Eliminar una factura
  const eliminarFactura = (numeroFactura) => {
    console.log("[FacturasContext] Eliminando factura:", numeroFactura);

    setFacturas((prev) =>
      prev.filter((f) => f.numeroFactura !== numeroFactura),
    );

    localStorage.setItem(
      "facturasPendientes",
      JSON.stringify(
        facturas.filter((f) => f.numeroFactura !== numeroFactura),
      ),
    );
  };

  // Limpiar todo
  const limpiarFacturas = () => {
    console.log("[FacturasContext] Limpiando todas las facturas pendientes");
    setFacturas([]);
    localStorage.removeItem("facturasPendientes");
  };

  // Total visual
  const totalFacturas = facturas.reduce(
    (acc, f) => acc + Number(f.total || 0),
    0,
  );

  //  Pagar factura
  const pagarFactura = async (factura, metodoPago) => {
    console.log(
      "[FacturasContext] Intentando PAGAR factura:",
      factura?.numeroFactura,
    );

    try {
      setLoading(true);
      setError(null);

      const facturaBD = await pagarFacturaUseCase({
        factura,
        metodoPago,
      });

      console.log(
        "[FacturasContext] Factura PAGADA OK:",
        facturaBD?.idFactura,
      );

      // Limpiar de pendientes
      eliminarFactura(factura.numeroFactura);

      return facturaBD;
    } catch (err) {
      console.error(
        "[FacturasContext] Error al PAGAR factura:",
        err,
      );
      setError(err.message);
      throw err;
    } finally {
      setLoading(false);
    }
  };

  // Cancelar factura
  const cancelarFactura = async (factura) => {
    console.log(
      "[FacturasContext] Intentando CANCELAR factura:",
      factura?.numeroFactura,
    );

    try {
      setLoading(true);
      setError(null);

      const facturaBD = await cancelarFacturaUseCase({
        factura,
      });

      console.log(
        "[FacturasContext] Factura CANCELADA OK:",
        facturaBD?.idFactura,
      );

      // Limpiar de pendientes
      eliminarFactura(factura.numeroFactura);

      return facturaBD;
    } catch (err) {
      console.error(
        "[FacturasContext] Error al CANCELAR factura:",
        err,
      );
      setError(err.message);
      throw err;
    } finally {
      setLoading(false);
    }
  };

  return (
    <FacturasContext.Provider
      value={{
        facturas,
        totalFacturas,
        agregarFacturas,
        eliminarFactura,
        limpiarFacturas,
        pagarFactura,
        cancelarFactura,
        loading,
        error,
      }}
    >
      {children}
    </FacturasContext.Provider>
  );
}

export const useFacturas = () => useContext(FacturasContext);
